import _ from 'underscore';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Select } from '@bingads-webui-react/primitive';
import { globalizationModelSetup } from '@bingads-webui-campaign/ads-globalization';

const CURRENCY_STRINGS = {
  ALL: _TL_('ALL'),
  AED: _TL_('AED'),
  ARS: _TL_('ARS'),
  AUD: _TL_('AUD'),
  BAM: _TL_('BAM'),
  BRL: _TL_('BRL'),
  CAD: _TL_('CAD'),
  CHF: _TL_('CHF'),
  CLP: _TL_('CLP'),
  CNY: _TL_('CNY'),
  COP: _TL_('COP'),
  DKK: _TL_('DKK'),
  EUR: _TL_('EUR'),
  GBP: _TL_('GBP'),
  HKD: _TL_('HKD'),
  IDR: _TL_('IDR'),
  ILS: _TL_('ILS'),
  INR: _TL_('INR'),
  ISK: _TL_('ISK'),
  JPY: _TL_('JPY'),
  MKD: _TL_('MKD'),
  MXN: _TL_('MXN'),
  MYR: _TL_('MYR'),
  NGN: _TL_('NGN'),
  NZD: _TL_('NZD'),
  PEN: _TL_('PEN'),
  PHP: _TL_('PHP'),
  PLN: _TL_('PLN'),
  RSD: _TL_('RSD'),
  SAR: _TL_('SAR'),
  SEK: _TL_('SEK'),
  SGD: _TL_('SGD'),
  THB: _TL_('THB'),
  TRY: _TL_('TRY'),
  TWD: _TL_('TWD'),
  USD: _TL_('USD'),
  VEF: _TL_('VEF'),
  VND: _TL_('VND'),
  ZAR: _TL_('ZAR'),
};

const pickCurrencies = currencies =>
  _.chain(currencies)
    .reduce((memo, currency) => {
      const outMemo = memo;
      outMemo[currency] = CURRENCY_STRINGS[currency];
      return outMemo;
    }, {})
    .pairs()
    .value(); // [ [currency, currencyString], ... ]

export function CurrencySelect({
  className, id, onChange, value: selected, i18n, permissions,
}) {
  const { CURRENCIES } = globalizationModelSetup({
    permissions,
    culture: i18n.getLocale(),
  });
  const currencies = pickCurrencies(CURRENCIES);
  const [selectedCurrency, setSelectedCurrency] = useState(selected);

  return (
    <Select
      id={id}
      className={className}
      value={selectedCurrency}
      onChange={(event) => {
        const language = event.target.value;
        setSelectedCurrency(language);
        onChange(language);
      }}
    >
      {currencies.map(([key, value]) =>
      (
        <option key={key} value={key}>
          {i18n.getString(value)}
        </option>
      ))}
    </Select>
  );
}

CurrencySelect.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  permissions: PropTypes.shape({}).isRequired,
};

CurrencySelect.defaultProps = {
  id: undefined,
  value: 'USD',
};
